/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';

/**
 * Fields a primary member may set when self-adding a new family member from the public site.
 * No Groups - that stays an admin-only concept.
 * @export
 * @interface WebApiPublicSiteDtoAddOwnFamilyMemberDto
 */
export interface WebApiPublicSiteDtoAddOwnFamilyMemberDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoAddOwnFamilyMemberDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoAddOwnFamilyMemberDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoAddOwnFamilyMemberDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoAddOwnFamilyMemberDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiPublicSiteDtoAddOwnFamilyMemberDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoAddOwnFamilyMemberDto
     */
    personalNumber?: string | null;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoAddOwnFamilyMemberDto interface.
 */
export function instanceOfWebApiPublicSiteDtoAddOwnFamilyMemberDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoAddOwnFamilyMemberDtoFromJSON(json: any): WebApiPublicSiteDtoAddOwnFamilyMemberDto {
    return WebApiPublicSiteDtoAddOwnFamilyMemberDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoAddOwnFamilyMemberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoAddOwnFamilyMemberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
        'personalNumber': !exists(json, 'personalNumber') ? undefined : json['personalNumber'],
    };
}

export function WebApiPublicSiteDtoAddOwnFamilyMemberDtoToJSON(value?: WebApiPublicSiteDtoAddOwnFamilyMemberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
        'personalNumber': value.personalNumber,
    };
}

